import Vue from 'vue'
import Vuex from 'vuex'
import { CacheSetOtherUserInfo } from '../utils/cache'

import pdf from './pdf'

const debug = process.env.NODE_ENV !== 'production'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo: {}
  },
  mutations: {
    vuexUpdateUserInfo (state, info) {
      state.userInfo = info
    },

    vuexUpdateInfoc (state, infoc) {
      state.infoc = infoc
    }
  },
  actions: {
    vuexUpdateUserInfo ({ dispatch, commit }, info) {
      commit('vuexUpdateUserInfo', info)

      if (info?.token) { // 与外部同步，有token需要登录pdf，没有则需要退出
        dispatch('pdf/login', info, { root: true })
      } else {
        CacheSetOtherUserInfo({})
        dispatch('pdf/logout', {}, { root: true })
      }
    },

    vuexToLogin () {
      window.parent.postMessage({ type: 'login' }, '*')
    },

    vuexBuyVip ({ state, dispatch }) {
      if (!state.userInfo?.token || !state?.pdf?.pdfUserInfo?.token) {
        dispatch('vuexToLogin')
        return
      }
      window.parent.postMessage({ type: 'buy' }, '*')
    }
  },
  getters: {
    isMember (state) {
      return state.userInfo?.isVip || false
    }
  },

  modules: {
    pdf
  },
  strict: debug
})
